import httpClient from '@/http-client'

export const dailyItemUsed = data => {
    return httpClient
        .get('/api/v1/reports/projects/daily-item-useds', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const dailyItemUsedExcel = data => {
    return httpClient
        .post('/api/v1/reports/projects/daily-item-useds/excels', data, {
            responseType: 'arraybuffer'
        })
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

export const dailyTaskUpdate = data => {
    return httpClient
        .get('/api/v1/reports/projects/daily-task-updates', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const dailyTaskUpdateExcel = data => {
    return httpClient
        .post('/api/v1/reports/projects/daily-task-updates/excels', data, {
            responseType: 'arraybuffer'
        })
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const project = (options = {}) => {
    return httpClient
        .get('/api/v1/reports/projects/projects', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const site = (options = {}) => {
    return httpClient
        .get('/api/v1/reports/projects/sites', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const product = (options = {}) => {
    return httpClient
        .get('/api/v1/reports/projects/products', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const category = (options = {}) => {
    return httpClient
        .get('/api/v1/reports/projects/categories', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const owner = (options = {}) => {
    return httpClient
        .get('/api/v1/reports/projects/owners', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const status = (options = {}) => {
    return httpClient
        .get('/api/v1/reports/projects/status', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const customer = (options = {}) => {
    return httpClient
        .get('/api/v1/reports/projects/customers', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const task = (options = {}) => {
    return httpClient
        .get('/api/v1/reports/projects/tasks', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default {
    dailyItemUsed,
    dailyItemUsedExcel,
    dailyTaskUpdate,
    dailyTaskUpdateExcel,
    project,
    site,
    product,
    owner,
    status,
    customer,
    category,
    task
}